import React, { useContext } from "react";
import OwLabel from "../../shared/OwLabel/OwLabel";
import UserService from "../../../services/UserService";
import IOrder_ItemUI from "../../../models/IOrder_ItemUI";
import SupplierContext from "../../../contexts/SupplierContext";

type Props = {
    row: IOrder_ItemUI;
};

export const LineItemQtyDeliveryEtaDetail = (props: Props) => {
    const supplierModel = useContext(SupplierContext);

    const deliveryEtaDetail =
        supplierModel.has_catalog_item_delivery_eta && props.row.Catalog_Item?.delivery_eta ? (
            <div className={"mt-2"}>
                <OwLabel title={"delivery_eta"} /> <div>{UserService.parseDate(props.row.Catalog_Item?.delivery_eta)}</div>
            </div>
        ) : null;

    return deliveryEtaDetail;
};
